import { createContext, useState, useEffect} from "react";

export const ResponsiveContext = createContext();

export const ResponsiveContextProvider = ( { children } ) => {
	const [phoneView, setPhoneView] = useState(window.innerWidth <= 1024);

	useEffect(() => {
		const handleResize = () => {
			setPhoneView(window.innerWidth <= 1024);
		}

		window.addEventListener('resize', handleResize)

		handleResize();

		return () => window.removeEventListener('resize', handleResize)
	}, [])


	return (
		<ResponsiveContext.Provider value={ { phoneView, setPhoneView } }>
			{children}
		</ResponsiveContext.Provider>
	)
}